<template>
    <div class="section-padding bg-slgray">
        <NewsletterSignup :data="data" />
    </div>
</template>

<script>
import NewsletterSignup from '@/components/newsletter-signup/NewsletterSignup.vue';
export default {
    components: {
        NewsletterSignup
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    }
};
</script>